/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dialog_Premium_TrialInputs */

const en_dialog_premium_trial = /** @type {(inputs: Dialog_Premium_TrialInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Try Premium for Free for ${i?.count} day`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Try Premium for Free for ${i?.count} days`);
	return /** @type {LocalizedString} */ ("dialog_premium_trial");
};

const es_dialog_premium_trial = /** @type {(inputs: Dialog_Premium_TrialInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Prueba Premium gratis por ${i?.count} día`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Prueba Premium gratis por ${i?.count} días`);
	return /** @type {LocalizedString} */ ("dialog_premium_trial");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Try Premium for Free for {count} day" |
* | "other" | "Try Premium for Free for {count} days" |
*
* @param {Dialog_Premium_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_trial = /** @type {((inputs: Dialog_Premium_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_trial(inputs)
	return en_dialog_premium_trial(inputs)
});